
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxGovernment.css';

const RedboxGovernment = () => {
  return (
    <>
      <Helmet>
        <title>Government | Redbox Global</title>
        <meta
          name="description"
          content="Public policy analysis, government affairs, regulatory developments, and global governance insights from Redbox Global."
        />
        <meta
          name="keywords"
          content="government policy, public affairs, global governance, regulatory policy, political economy, Redbox Global Government"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/government" />
        <meta property="og:title" content="Government | Redbox Global" />
        <meta
          property="og:description"
          content="In-depth coverage of public policy, government affairs, and global regulatory developments."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1529101091764-c3526daf38fe?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Government | Redbox Global" />
        <meta
          name="twitter:description"
          content="Global government policy and regulatory analysis from Redbox Global."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1529101091764-c3526daf38fe?w=1200&h=630&fit=crop"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/government" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Government</h1>
          <p className="page-subtitle">
            Public policy, governance, and global regulatory developments
          </p>
        </div>

        <div className="page-content">

          {/* Featured Article */}
          <a
            href="/article/global-policy-shifts-2026"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1529101091764-c3526daf38fe?w=1200&h=600&fit=crop"
                  alt="Government building"
                />
              </div>
              <div className="featured-content">
               
                <h2>Major Global Policy Shifts Reshaping International Governance</h2>
                <p>
                  Governments worldwide are introducing sweeping regulatory reforms
                  impacting trade, digital infrastructure, energy policy, and national security.
                </p>
                <span className="article-meta">February 11, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a
              href="/article/digital-governance-frameworks"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Digital governance concept"
                  />
                </div>
                <div className="article-content">
            
                  <h2>Emerging Digital Governance Frameworks Across Major Economies</h2>
                  <p>
                    How nations are redefining data sovereignty, cybersecurity,
                    and artificial intelligence oversight.
                  </p>
                  <span className="article-meta">February 8, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/public-sector-investment-2026"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1460472178825-e5240623afd5?w=600&h=400&fit=crop"
                    alt="Public infrastructure"
                  />
                </div>
                <div className="article-content">
           
                  <h2>Strategic Public Sector Investment Trends for 2026</h2>
                  <p>
                    Infrastructure modernization, green energy funding, and
                    digital transformation dominate government spending priorities.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/geopolitical-risk-analysis"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1483721310020-03333e577078?w=600&h=400&fit=crop"
                    alt="Geopolitical world map"
                  />
                </div>
                <div className="article-content">
                
                  <h2>Geopolitical Risk and Its Impact on Global Markets</h2>
                  <p>
                    An assessment of shifting alliances, regional conflicts,
                    and their economic implications.
                  </p>
                  <span className="article-meta">February 3, 2026</span>
                </div>
              </article>
            </a>

          </div>

        </div>
      </div>
    </>
  );
};

export default RedboxGovernment;
